"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 12c-.63.84-1 1.88-1 3 0 2.76 2.24 5 5 5 1.12 0 2.16-.37 3-1-3.87 0-7-3.13-7-7m10-8c-1.13 0-2.16.37-3 1 3.87.01 7 3.14 7 7 .63-.84 1-1.88 1-3 0-2.76-2.24-5-5-5",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 7c-.6 0-1.17.11-1.7.3-.19.53-.3 1.1-.3 1.7 0 2.76 2.24 5 5 5 .6 0 1.17-.11 1.7-.3.19-.53.3-1.1.3-1.7 0-2.76-2.24-5-5-5",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M8 9c-.63.84-1 1.88-1 3 0 2.76 2.24 5 5 5 1.12 0 2.16-.37 3-1-3.87-.01-7-3.14-7-7",
  opacity: ".3"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M15 2c-2.71 0-5.05 1.54-6.22 3.78-1.28.67-2.34 1.72-3 3C3.54 9.95 2 12.29 2 15c0 3.87 3.13 7 7 7 2.71 0 5.05-1.54 6.22-3.78 1.28-.67 2.34-1.72 3-3C20.46 14.05 22 11.71 22 9c0-3.87-3.13-7-7-7M9 20c-2.76 0-5-2.24-5-5 0-1.12.37-2.16 1-3 0 3.87 3.13 7 7 7-.84.63-1.88 1-3 1m3-3c-2.76 0-5-2.24-5-5 0-1.12.37-2.16 1-3 0 3.86 3.13 6.99 7 7-.84.63-1.88 1-3 1m4.7-3.3c-.53.19-1.1.3-1.7.3-2.76 0-5-2.24-5-5 0-.6.11-1.17.3-1.7.53-.19 1.1-.3 1.7-.3 2.76 0 5 2.24 5 5 0 .6-.11 1.17-.3 1.7M19 12c0-3.86-3.13-6.99-7-7 .84-.63 1.87-1 3-1 2.76 0 5 2.24 5 5 0 1.12-.37 2.16-1 3"
}, "3")], 'AnimationTwoTone');